<!--
 * @Description:修改标签
 * @Date: 2023/4/20 下午3:41:37
-->
<template>
  <BaseDialog
    width="450px"
    :visible="true"
    :model-value="true"
    :show-close="true"
    :close-on-press-escape="true"
    :close-on-click-modal="false"
    title="修改标签"
  >
    <div style="padding: 20px">
      <BaseForm
        ref="formRef"
        :model="formData"
        label-width="auto"
        label-position="right"
      >
        <BaseFormItem
          label="姓名："
          prop="name"
          :rules="[{ required: true, message: '姓名必填' }]"
        >
          <BaseInput
            :disabled="true"
            style="width: 100%"
            placeholder="请输入姓名"
            v-model="formData.name"
            maxlength="30"
          ></BaseInput>
        </BaseFormItem>
        <BaseFormItem
          label="手机号："
          prop="phone"
          :rules="[{ required: true, message: '手机号必填' }]"
        >
          <BaseInput
            :disabled="true"
            style="width: 100%"
            placeholder="请输入手机号"
            v-model="formData.phone"
            type="tel"
            maxlength="11"
          ></BaseInput>
        </BaseFormItem>
        <BaseFormItem label="人员标签：" prop="userTag">
          <BaseAutocomplete
            style="width: 100%"
            placeholder="请输入人员标签"
            v-model="formData.userTag"
            :fetch-suggestions="
              async (queryString, cb) => {
                const { data } = await userTags({
                  projectId: row.projectId
                });
                const list = data.map(item => {
                  return { value: item.label, label: item.label };
                });
                if (list.length === 1 && list[0].value === '未设置') {
                  return cb([]);
                }
                return cb(
                  list.filter(
                    i => !queryString || i.value?.indexOf(queryString) > -1
                  )
                );
              }
            "
          ></BaseAutocomplete>
        </BaseFormItem>
      </BaseForm>
    </div>
    <template #footer>
      <BaseButton @click="onCancel" type="default">取消</BaseButton>
      <BaseButton :click="onSave" type="primary">确定</BaseButton>
    </template>
  </BaseDialog>
</template>
<script lang="tsx" setup>
import { reactive, ref } from 'vue';
import {
  BaseDialog,
  BaseForm,
  BaseFormItem,
  BaseFormRef,
  BaseInput,
  BaseButton,
  BaseAutocomplete
} from 'xrk-components';
import { userTags } from '@/views/project-task/src/data-source/apis';
import { modifyProjectPeopleUserTag } from '../data-source/apis';
const props = withDefaults(
  defineProps<{
    remove?: () => {};
    row: any;
  }>(),
  {
    remove() {
      return () => ({});
    }
  }
);
const emits = defineEmits(['success']);
const formRef = ref<BaseFormRef>(null);
const formData = reactive<{
  name: string;
  phone: number;
  userTag: string;
}>({
  name: props.row.name,
  phone: props.row.phone,
  userTag: props.row.userTag
});
const onSave = async () => {
  await formRef.value.validate();
  await modifyProjectPeopleUserTag({
    projectId: props.row.projectId,
    userId: props.row.userId,
    userTag: formData.userTag
  });
  emits('success');
  onCancel();
};
const onCancel = () => {
  props.remove();
};
</script>
